import React from 'react';
import { Col } from '@cvent/carina/components/Col';
import { Row } from '@cvent/carina/components/Row';
import { injectTestId } from '@cvent/nucleus-test-automation';
import useBreakpoints from '@hooks/useBreakpoints';
import useBlockTheme from '@cvent/blocks/hooks/useTheme';
import { CSSObject } from '@emotion/react';
import EventLogo from './EventLogo';
import { Z_INDEX } from '../shared/zIndex';

interface LandingNavigationProps {
  eventId: string;
  logoSrc: string;
  navBackgroundColorOverride?: string;
  useCustomLogoLink?: boolean;
}

const useStyles = ({ navBackgroundColorOverride }): Record<string, CSSObject> => {
  const { block } = useBlockTheme();

  return {
    desktopContainer: {
      backgroundColor: navBackgroundColorOverride || block?.base,
      'div[data-layout="col"]': {
        transition: 'none !important'
      },
      display: ''
    },
    stickyContainer: {
      backgroundColor: navBackgroundColorOverride || block?.base,
      position: 'relative',
      top: 0,
      zIndex: Z_INDEX.APP_LAYOUT_HEADER,
      display: ''
    },
    desktopContent: {
      maxWidth: null,
      margin: 'auto',
      maxHeight: 150,
      minHeight: 80,
      display: 'flex',
      alignItems: 'center',
      flex: '0'
    }
  };
};

function LandingNavigation({
  eventId,
  logoSrc,
  navBackgroundColorOverride,
  useCustomLogoLink
}: LandingNavigationProps): JSX.Element {
  const { isMobileOrTablet, isMobile } = useBreakpoints();

  const styles = useStyles({
    navBackgroundColorOverride
  });

  const baseLink = `/events/${eventId}`;
  const homeLink = useCustomLogoLink ? '#' : `${baseLink}/info`;
  const logo = <EventLogo logoSrc={logoSrc} logoLink={homeLink} logoWidth={null} testID="page-header-logo-image" />;

  return (
    <div
      role="banner"
      {...injectTestId('navigation-landing')}
      css={[isMobileOrTablet ? {} : styles.desktopContainer, styles.stickyContainer]}
    >
      <div css={[styles.desktopContent]}>
        <Row margin={{ top: isMobile ? 16 : 24, bottom: isMobile ? 16 : 24 }}>
          <Col
            flex={{ display: 'flex', alignItems: 'center' }}
            width={isMobileOrTablet ? 'fill' : 'content'}
            padding={24}
          >
            {logo}
          </Col>
          {!isMobileOrTablet && <Col width="fill" />}
        </Row>
      </div>
    </div>
  );
}

export default LandingNavigation;
